module.exports = __webpack_public_path__ + "img/checklist.78d97020.jpg";